import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./getHeaderOptions";
import logger from "../utils/logger";

const API_ENDPOINT = API_URL + "api/v1";

/**
 * Send test email using Google Mail API
 * @param to - Recipient email address
 * @param subject - Email subject
 * @param message - Email content (HTML or plain text)
 * @param contentId - Optional content ID
 * @param leadId - Optional lead ID
 */
export const sendTestEmail = async (payload: {
  to: string;
  subject: string;
  message: string;
  contentId?: string;
  leadId?: string;
}): Promise<any> => {
  try {
    logger.log('[EmailService] Sending test email:', {
      to: payload.to,
      subject: payload.subject,
      hasMessage: !!payload.message,
      contentId: payload.contentId,
      leadId: payload.leadId
    });

    const response = await axios.post(
      `${API_ENDPOINT}/utility/send-mail-by-google`,
      payload,
      {
        headers: {
          ...getHeaderOptions,
          Authorization: localStorage.getItem("auth_token") || "",
          "token-check-disable": "true",
        }
      }
    );

    logger.log('[EmailService] Test email sent successfully:', response.data);
    return response;
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to send test email';
    logger.error('[EmailService] Test email failed:', errorMessage);
    throw new Error(errorMessage);
  }
};

/**
 * Check if user has Gmail send permission
 */
export const hasGmailSendScope = (userDetails: any): boolean => {
  const googleTokensScope = userDetails?.googleTokensScope;

  if (!googleTokensScope) {
    logger.log('[EmailService] No Google tokens scope found');
    return false;
  }

  const hasScope = googleTokensScope.includes('https://www.googleapis.com/auth/gmail.send');
  logger.log('[EmailService] Gmail send scope check:', {
    googleTokensScope,
    hasScope
  });

  return hasScope;
};
